import { createContext, useContext, useEffect, useMemo, useState } from "react";

export const UserContext = createContext();

const userSearchPreferencesInitialState = {
  suppliers: [],
  offers: "show_all_products",
  others: {
    clear_search: false,
    hide_supplier: false,
    hide_manufacturer: false,
    global_search: false
  }
};

const poSearchPreferencesInitialState = {
  offers: "show_all_products",
  others: {
    hide_manufacturer: false
  }
};

export default function UserContextProvider({ children }) {
  const [userSearchPreferences, setUserSearchPreferences] = useState(
    userSearchPreferencesInitialState
  );
  const [poSearchPreferences, setPoSearchPreferences] = useState(
    poSearchPreferencesInitialState
  );

  const getSavedSuppliers = () => {
    const searchPreferences =
      JSON.parse(localStorage.getItem("user_search_preferences")) || "";

    let updatedSearchPreferences = {};

    if (searchPreferences) {
      updatedSearchPreferences = {
        ...updatedSearchPreferences,
        ...searchPreferences
      };
    }

    if (Object.keys(updatedSearchPreferences).length > 0) {
      setUserSearchPreferences(updatedSearchPreferences);
    }
  };

  useEffect(() => {
    getSavedSuppliers();
  }, []);

  const persistUserSearchPreferences = (updatedSearchPreferences) => {
    setUserSearchPreferences(updatedSearchPreferences);

    localStorage.setItem(
      "user_search_preferences",
      JSON.stringify(updatedSearchPreferences)
    );
  };

  const persistPoSearchPreferences = (updatedSearchPreferences) => {
    setPoSearchPreferences(updatedSearchPreferences);
  };

  const userSearchPreferencesValues = useMemo(
    () => ({
      isFilterDeal: userSearchPreferences.offers === "products_with_offers",
      isSearchClear: userSearchPreferences?.others?.clear_search || false,
      isHideManufacturer:
        userSearchPreferences?.others?.hide_manufacturer || false,
      isHideSupplier: userSearchPreferences?.others?.hide_supplier || false,
      isGlobalSearch: userSearchPreferences?.others?.global_search || false
    }),
    [userSearchPreferences]
  );

  const poSearchPreferencesValues = useMemo(
    () => ({
      isFilterDealPO: poSearchPreferences.offers === "products_with_offers",
      isHideManufacturerPO:
        poSearchPreferences?.others?.hide_manufacturer || false
    }),
    [poSearchPreferences]
  );

  const userContextValues = useMemo(
    () => ({
      userSearchPreferences,
      userSearchPreferencesValues,
      persistUserSearchPreferences,
      poSearchPreferences,
      poSearchPreferencesValues,
      persistPoSearchPreferences
    }),
    [
      userSearchPreferencesValues,
      userSearchPreferences,
      poSearchPreferences,
      poSearchPreferencesValues
    ]
  );

  return (
    <UserContext.Provider value={userContextValues}>
      {children}
    </UserContext.Provider>
  );
}

export const useUserContext = () => useContext(UserContext);
